import _toConsumableArray from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _slicedToArray from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _classCallCheck from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/createClass.js";
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
import * as parseley from 'parseley';
import { compareSpecificity } from 'parseley';
var Ast = /*#__PURE__*/Object.freeze({
  __proto__: null
});
var Types = /*#__PURE__*/Object.freeze({
  __proto__: null
});
var treeify = function treeify(nodes) {
  return '▽\n' + treeifyArray(nodes, thinLines);
};
var thinLines = [['├─', '│ '], ['└─', '  ']];
var heavyLines = [['┠─', '┃ '], ['┖─', '  ']];
var doubleLines = [['╟─', '║ '], ['╙─', '  ']];
function treeifyArray(nodes) {
  var tpl = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : heavyLines;
  return prefixItems(tpl, nodes.map(function (n) {
    return treeifyNode(n);
  }));
}
function treeifyNode(node) {
  switch (node.type) {
    case 'terminal':
      {
        var vctr = node.valueContainer;
        return "\u25C1 #".concat(vctr.index, " ").concat(JSON.stringify(vctr.specificity), " ").concat(vctr.value);
      }
    case 'tagName':
      return "\u25FB Tag name\n".concat(treeifyArray(node.variants, doubleLines));
    case 'attrValue':
      return "\u25A3 Attr value: ".concat(node.name, "\n").concat(treeifyArray(node.matchers, doubleLines));
    case 'attrPresence':
      return "\u25E8 Attr presence: ".concat(node.name, "\n").concat(treeifyArray(node.cont));
    case 'pushElement':
      return "\u25C9 Push element: ".concat(node.combinator, "\n").concat(treeifyArray(node.cont, thinLines));
    case 'popElement':
      return "\u25CC Pop element\n".concat(treeifyArray(node.cont, thinLines));
    case 'variant':
      return "\u25C7 = ".concat(node.value, "\n").concat(treeifyArray(node.cont));
    case 'matcher':
      return "\u25C8 ".concat(node.matcher, " \"").concat(node.value, "\"").concat(node.modifier || '', "\n").concat(treeifyArray(node.cont));
  }
}
function prefixItems(tpl, items) {
  return items.map(function (item, i, _ref) {
    var length = _ref.length;
    return prefixItem(tpl, item, i === length - 1);
  }).join('\n');
}
function prefixItem(tpl, item) {
  var tail = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  var tpl1 = tpl[tail ? 1 : 0];
  return tpl1[0] + item.split('\n').join('\n' + tpl1[1]);
}
var TreeifyBuilder = /*#__PURE__*/Object.freeze({
  __proto__: null,
  treeify: treeify
});
var DecisionTree = /*#__PURE__*/function () {
  function DecisionTree(input) {
    _classCallCheck(this, DecisionTree);
    this.branches = weave(toAstTerminalPairs(input));
  }
  _createClass(DecisionTree, [{
    key: "build",
    value: function build(builder) {
      return builder(this.branches);
    }
  }]);
  return DecisionTree;
}();
function toAstTerminalPairs(array) {
  var len = array.length;
  var results = new Array(len);
  for (var i = 0; i < len; i++) {
    var _array$i = _slicedToArray(array[i], 2),
      selectorString = _array$i[0],
      val = _array$i[1];
    var ast = preprocess(parseley.parse1(selectorString));
    results[i] = {
      ast: ast,
      terminal: {
        type: 'terminal',
        valueContainer: {
          index: i,
          value: val,
          specificity: ast.specificity
        }
      }
    };
  }
  return results;
}
function preprocess(ast) {
  reduceSelectorVariants(ast);
  parseley.normalize(ast);
  return ast;
}
function reduceSelectorVariants(ast) {
  var newList = [];
  ast.list.forEach(function (sel) {
    switch (sel.type) {
      case 'class':
        newList.push({
          matcher: '~=',
          modifier: null,
          name: 'class',
          namespace: null,
          specificity: sel.specificity,
          type: 'attrValue',
          value: sel.name
        });
        break;
      case 'id':
        newList.push({
          matcher: '=',
          modifier: null,
          name: 'id',
          namespace: null,
          specificity: sel.specificity,
          type: 'attrValue',
          value: sel.name
        });
        break;
      case 'combinator':
        reduceSelectorVariants(sel.left);
        newList.push(sel);
        break;
      case 'universal':
        break;
      default:
        newList.push(sel);
        break;
    }
  });
  ast.list = newList;
}
function weave(items) {
  var branches = [];
  while (items.length) {
    var topKind = findTopKey(items, function (sel) {
      return true;
    }, getSelectorKind);
    var _breakByKind = breakByKind(items, topKind),
      matches = _breakByKind.matches,
      nonmatches = _breakByKind.nonmatches,
      empty = _breakByKind.empty;
    items = nonmatches;
    if (matches.length) {
      branches.push(branchOfKind(topKind, matches));
    }
    if (empty.length) {
      branches.push.apply(branches, _toConsumableArray(terminate(empty)));
    }
  }
  return branches;
}
function terminate(items) {
  var results = [];
  var _iterator = _createForOfIteratorHelper(items),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var item = _step.value;
      var terminal = item.terminal;
      if (terminal.type === 'terminal') {
        results.push(terminal);
      } else {
        var _partition = partition(terminal.cont, function (node) {
            return node.type === 'terminal';
          }),
          matches = _partition.matches,
          rest = _partition.rest;
        matches.forEach(function (node) {
          return results.push(node);
        });
        if (rest.length) {
          terminal.cont = rest;
          results.push(terminal);
        }
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  return results;
}
function breakByKind(items, selectedKind) {
  var matches = [];
  var nonmatches = [];
  var empty = [];
  var _iterator2 = _createForOfIteratorHelper(items),
    _step2;
  try {
    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
      var item = _step2.value;
      var simpsels = item.ast.list;
      if (simpsels.length) {
        var isMatch = simpsels.some(function (node) {
          return getSelectorKind(node) === selectedKind;
        });
        (isMatch ? matches : nonmatches).push(item);
      } else {
        empty.push(item);
      }
    }
  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }
  return {
    matches: matches,
    nonmatches: nonmatches,
    empty: empty
  };
}
function getSelectorKind(sel) {
  switch (sel.type) {
    case 'attrPresence':
      return "attrPresence ".concat(sel.name);
    case 'attrValue':
      return "attrValue ".concat(sel.name);
    case 'combinator':
      return "combinator ".concat(sel.combinator);
    default:
      return sel.type;
  }
}
function branchOfKind(kind, items) {
  if (kind === 'tag') {
    return tagNameBranch(items);
  }
  if (kind.startsWith('attrValue ')) {
    return attrValueBranch(kind.substring(10), items);
  }
  if (kind.startsWith('attrPresence ')) {
    return attrPresenceBranch(kind.substring(13), items);
  }
  if (kind === 'combinator >') {
    return combinatorBranch('>', items);
  }
  if (kind === 'combinator +') {
    return combinatorBranch('+', items);
  }
  throw new Error("Unsupported selector kind: ".concat(kind));
}
function tagNameBranch(items) {
  var groups = spliceAndGroup(items, function (x) {
    return x.type === 'tag';
  }, function (x) {
    return x.name;
  });
  var variants = Object.entries(groups).map(function (_ref2) {
    var _ref3 = _slicedToArray(_ref2, 2),
      name = _ref3[0],
      group = _ref3[1];
    return {
      type: 'variant',
      value: name,
      cont: weave(group.items)
    };
  });
  return {
    type: 'tagName',
    variants: variants
  };
}
function attrPresenceBranch(name, items) {
  var _iterator3 = _createForOfIteratorHelper(items),
    _step3;
  try {
    for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
      var item = _step3.value;
      spliceSimpleSelector(item, function (x) {
        return x.type === 'attrPresence' && x.name === name;
      });
    }
  } catch (err) {
    _iterator3.e(err);
  } finally {
    _iterator3.f();
  }
  return {
    type: 'attrPresence',
    name: name,
    cont: weave(items)
  };
}
function attrValueBranch(name, items) {
  var groups = spliceAndGroup(items, function (x) {
    return x.type === 'attrValue' && x.name === name;
  }, function (x) {
    return "".concat(x.matcher, " ").concat(x.modifier || '', " ").concat(x.value);
  });
  var matchers = [];
  for (var _i = 0, _Object$values = Object.values(groups); _i < _Object$values.length; _i++) {
    var group = _Object$values[_i];
    var sel = group.oneSimpleSelector;
    var predicate = getAttrPredicate(sel);
    var continuation = weave(group.items);
    matchers.push({
      type: 'matcher',
      matcher: sel.matcher,
      modifier: sel.modifier,
      value: sel.value,
      predicate: predicate,
      cont: continuation
    });
  }
  return {
    type: 'attrValue',
    name: name,
    matchers: matchers
  };
}
function getAttrPredicate(sel) {
  if (sel.modifier === 'i') {
    var expected = sel.value.toLowerCase();
    switch (sel.matcher) {
      case '=':
        return function (actual) {
          return expected === actual.toLowerCase();
        };
      case '~=':
        return function (actual) {
          return actual.toLowerCase().split(/[ \t]+/).includes(expected);
        };
      case '^=':
        return function (actual) {
          return actual.toLowerCase().startsWith(expected);
        };
      case '$=':
        return function (actual) {
          return actual.toLowerCase().endsWith(expected);
        };
      case '*=':
        return function (actual) {
          return actual.toLowerCase().includes(expected);
        };
      case '|=':
        return function (actual) {
          var lower = actual.toLowerCase();
          return expected === lower || lower.startsWith(expected) && lower[expected.length] === '-';
        };
    }
  } else {
    var _expected = sel.value;
    switch (sel.matcher) {
      case '=':
        return function (actual) {
          return _expected === actual;
        };
      case '~=':
        return function (actual) {
          return actual.split(/[ \t]+/).includes(_expected);
        };
      case '^=':
        return function (actual) {
          return actual.startsWith(_expected);
        };
      case '$=':
        return function (actual) {
          return actual.endsWith(_expected);
        };
      case '*=':
        return function (actual) {
          return actual.includes(_expected);
        };
      case '|=':
        return function (actual) {
          return _expected === actual || actual.startsWith(_expected) && actual[_expected.length] === '-';
        };
    }
  }
}
function combinatorBranch(combinator, items) {
  var groups = spliceAndGroup(items, function (x) {
    return x.type === 'combinator' && x.combinator === combinator;
  }, function (x) {
    return parseley.serialize(x.left);
  });
  var leftItems = [];
  for (var _i2 = 0, _Object$values2 = Object.values(groups); _i2 < _Object$values2.length; _i2++) {
    var group = _Object$values2[_i2];
    var rightCont = weave(group.items);
    var leftAst = group.oneSimpleSelector.left;
    leftItems.push({
      ast: leftAst,
      terminal: {
        type: 'popElement',
        cont: rightCont
      }
    });
  }
  return {
    type: 'pushElement',
    combinator: combinator,
    cont: weave(leftItems)
  };
}
function spliceAndGroup(items, predicate, keyCallback) {
  var groups = {};
  var _loop = function _loop() {
    var bestKey = findTopKey(items, predicate, keyCallback);
    var bestKeyPredicate = function bestKeyPredicate(sel) {
      return predicate(sel) && keyCallback(sel) === bestKey;
    };
    var hasBestKeyPredicate = function hasBestKeyPredicate(item) {
      return item.ast.list.some(bestKeyPredicate);
    };
    var _partition2 = partition1(items, hasBestKeyPredicate),
      matches = _partition2.matches,
      rest = _partition2.rest;
    var oneSimpleSelector = null;
    var _iterator4 = _createForOfIteratorHelper(matches),
      _step4;
    try {
      for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
        var item = _step4.value;
        var splicedNode = spliceSimpleSelector(item, bestKeyPredicate);
        if (!oneSimpleSelector) {
          oneSimpleSelector = splicedNode;
        }
      }
    } catch (err) {
      _iterator4.e(err);
    } finally {
      _iterator4.f();
    }
    if (oneSimpleSelector == null) {
      throw new Error('No simple selector is found.');
    }
    groups[bestKey] = {
      oneSimpleSelector: oneSimpleSelector,
      items: matches
    };
    items = rest;
  };
  while (items.length) {
    _loop();
  }
  return groups;
}
function spliceSimpleSelector(item, predicate) {
  var simpsels = item.ast.list;
  var matches = new Array(simpsels.length);
  var firstIndex = -1;
  for (var i = simpsels.length; i-- > 0;) {
    if (predicate(simpsels[i])) {
      matches[i] = true;
      firstIndex = i;
    }
  }
  if (firstIndex == -1) {
    throw new Error("Couldn't find the required simple selector.");
  }
  var result = simpsels[firstIndex];
  item.ast.list = simpsels.filter(function (sel, i) {
    return !matches[i];
  });
  return result;
}
function findTopKey(items, predicate, keyCallback) {
  var candidates = {};
  var _iterator5 = _createForOfIteratorHelper(items),
    _step5;
  try {
    for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
      var item = _step5.value;
      var candidates1 = {};
      var _iterator6 = _createForOfIteratorHelper(item.ast.list.filter(predicate)),
        _step6;
      try {
        for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
          var node = _step6.value;
          candidates1[keyCallback(node)] = true;
        }
      } catch (err) {
        _iterator6.e(err);
      } finally {
        _iterator6.f();
      }
      for (var _i4 = 0, _Object$keys = Object.keys(candidates1); _i4 < _Object$keys.length; _i4++) {
        var key = _Object$keys[_i4];
        if (candidates[key]) {
          candidates[key]++;
        } else {
          candidates[key] = 1;
        }
      }
    }
  } catch (err) {
    _iterator5.e(err);
  } finally {
    _iterator5.f();
  }
  var topKind = '';
  var topCounter = 0;
  for (var _i3 = 0, _Object$entries = Object.entries(candidates); _i3 < _Object$entries.length; _i3++) {
    var entry = _Object$entries[_i3];
    if (entry[1] > topCounter) {
      topKind = entry[0];
      topCounter = entry[1];
    }
  }
  return topKind;
}
function partition(src, predicate) {
  var matches = [];
  var rest = [];
  var _iterator7 = _createForOfIteratorHelper(src),
    _step7;
  try {
    for (_iterator7.s(); !(_step7 = _iterator7.n()).done;) {
      var x = _step7.value;
      if (predicate(x)) {
        matches.push(x);
      } else {
        rest.push(x);
      }
    }
  } catch (err) {
    _iterator7.e(err);
  } finally {
    _iterator7.f();
  }
  return {
    matches: matches,
    rest: rest
  };
}
function partition1(src, predicate) {
  var matches = [];
  var rest = [];
  var _iterator8 = _createForOfIteratorHelper(src),
    _step8;
  try {
    for (_iterator8.s(); !(_step8 = _iterator8.n()).done;) {
      var x = _step8.value;
      if (predicate(x)) {
        matches.push(x);
      } else {
        rest.push(x);
      }
    }
  } catch (err) {
    _iterator8.e(err);
  } finally {
    _iterator8.f();
  }
  return {
    matches: matches,
    rest: rest
  };
}
var Picker = /*#__PURE__*/function () {
  function Picker(f) {
    _classCallCheck(this, Picker);
    this.f = f;
  }
  _createClass(Picker, [{
    key: "pickAll",
    value: function pickAll(el) {
      return this.f(el);
    }
  }, {
    key: "pick1",
    value: function pick1(el) {
      var preferFirst = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var results = this.f(el);
      var len = results.length;
      if (len === 0) {
        return null;
      }
      if (len === 1) {
        return results[0].value;
      }
      var comparator = preferFirst ? comparatorPreferFirst : comparatorPreferLast;
      var result = results[0];
      for (var i = 1; i < len; i++) {
        var next = results[i];
        if (comparator(result, next)) {
          result = next;
        }
      }
      return result.value;
    }
  }]);
  return Picker;
}();
function comparatorPreferFirst(acc, next) {
  var diff = compareSpecificity(next.specificity, acc.specificity);
  return diff > 0 || diff === 0 && next.index < acc.index;
}
function comparatorPreferLast(acc, next) {
  var diff = compareSpecificity(next.specificity, acc.specificity);
  return diff > 0 || diff === 0 && next.index > acc.index;
}
export { Ast, DecisionTree, Picker, TreeifyBuilder as Treeify, Types };